import {
  EAdminPortalClientPath,
  EClientPath,
  EMarketingClientPath,
} from '~/models/api'

export type TAppNavItem = {
  name: string
  path?: EClientPath | EMarketingClientPath | EAdminPortalClientPath
  children?: TAppNavItem[]
}
const navItems: TAppNavItem[] = [
  {
    name: 'Home',
    path: EMarketingClientPath.home,
  },
  {
    name: 'Pricing',
    path: EMarketingClientPath.pricing,
  },
  {
    name: 'Help',
    children: [
      {
        name: 'FAQ',
        path: EMarketingClientPath.faq,
      },
      {
        name: 'Support',
        path: EMarketingClientPath.supportAndContact,
      },
    ],
  },
]
export default navItems
